import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { makeApiRequests } from '../../helpers/api';
import { ENDPOINTS } from '../../helpers/constants';

const groups = {
  phone: [['cellPhone', 'Phone number', 40]],
  address: [['propertyAddress', 'Property address', 250], ['propertyCity', 'Property city', 100], ['propertyState', 'State', 50], ['zipCode', 'ZIP code', 10]]
};

export default function ContactQuickEditor({ contact, kind, onSaved, onCancel, onOpenRecord }) {
  const fields = groups[kind];
  const initial = useRef(Object.fromEntries(fields.map(([key]) => [key, contact[key] == null ? '' : String(contact[key])])));
  const [values, setValues] = useState(initial.current);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const busy = useRef(false);
  const active = useRef(true);
  useEffect(() => () => { active.current = false; }, []);
  async function save(event) {
    event.preventDefault();
    if (busy.current) return;
    busy.current = true; setSaving(true); setError('');
    const result = await makeApiRequests({ endpoint: `${ENDPOINTS.CONTACTS_WITH_ID('top-producer/' + contact._id)}/quick-edit`,
      method: 'PUT', requestBody: { kind, values, expected: initial.current } });
    if (!active.current) return;
    busy.current = false; setSaving(false);
    if (result.error || !result.response?.contact || result.response.contact._id !== contact._id) {
      setError(result.error || 'The save was not confirmed. Close and reopen this customer to check their details.');
      return;
    }
    onSaved(result.response.contact);
  }
  return <Form className="border rounded p-3 my-2 bg-light" onSubmit={save} aria-label={`Edit ${kind === 'phone' ? 'phone number' : 'property address'}`}>
    <h3 className="h6">Edit {kind === 'phone' ? 'phone number' : 'property address'}</h3>
    {error && <Alert variant="danger" role="alert">{error}</Alert>}
    <fieldset disabled={saving}>
      {fields.map(([key, label, maxLength], index) => <Form.Group key={key} controlId={`quick-${key}`}>
        <Form.Label>{label}</Form.Label>
        <Form.Control autoFocus={index === 0} type={key === 'cellPhone' ? 'tel' : 'text'} value={values[key]} maxLength={maxLength}
          onChange={event => setValues(old => ({ ...old, [key]: event.target.value }))} />
      </Form.Group>)}
      {kind === 'address' && contact.sameMailingAddress && <p className="small text-muted">The mailing address will match, as selected in this customer’s record.</p>}
      <Button type="submit" size="sm" className="mr-2">{saving ? 'Saving…' : 'Save'}</Button>
      <Button type="button" size="sm" variant="outline-secondary" onClick={onCancel}>Cancel</Button>
      <Button type="button" variant="link" size="sm" onClick={onOpenRecord}>Open full record</Button>
    </fieldset>
  </Form>;
}
